import { memo, useMemo, useState } from 'react';

import { useLanguage } from '@languages/index';
import { Settings } from 'types/settings';
import { BrandDto } from 'api/repositories/brand/brand.types';
import Checkbox from '@components/checkbox';
import Button from '@components/button';
import { getCurrencyMultiplier, makeMoneyText } from 'helpers/currency';

export interface InspectionAgreementsModalProps {
  brand: BrandDto;
  settings: Settings;
  onConfirm: () => void;
}

const InspectionAgreementsModal = ({ brand, settings, onConfirm }: InspectionAgreementsModalProps) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.pages.campaigns.stepOne.modalInspectionAgreements,
  };
  const [isAgreed, setIsAgreed] = useState<boolean>(false);

  const createPriceText = useMemo(() => {
    const priceInspection = brand.priceInspection || settings.priceInspection || 0;
    const currencyMultiplier = getCurrencyMultiplier(brand.currency);

    return makeMoneyText(
      priceInspection * currencyMultiplier,
      10000,
      (moneyText) => languageTexts._price(moneyText, settings.currencyText),
      (moneyText) => languageTexts._price_10000(moneyText, settings.currencyText),
    );
  }, [brand.priceInspection, brand.currency, settings.priceInspection, settings.currencyText]);

  return (
    <div className="bg-white px-[30px] py-[35px]">
      <div className="text-[22px] font-bold">{languageTexts.title}</div>
      <div className="mt-[30px] flex flex-col gap-[15px] text-[15px]">
        <div>{languageTexts._agreement_1(createPriceText)}</div>
        <div>{languageTexts.agreement_2}</div>
        <div>{languageTexts.agreement_3}</div>
        <div>{languageTexts.agreement_4}</div>
        <div className="text-[red]">{languageTexts.agreement_5}</div>
        <div className="text-[red]">{languageTexts.agreement_6}</div>
      </div>
      <div className="mt-[30px]">
        <Checkbox text={languageTexts.check_is_agreed} checked={isAgreed} onClick={() => setIsAgreed(!isAgreed)} />
      </div>
      <div className="mt-[30px]">
        <Button
          className={'w-full py-3 flex justify-center text-center text-base'}
          textColor={'WHITE'}
          buttonColor={isAgreed ? 'BLACK' : '#C8C8C8'}
          text={languageTexts.confirm}
          onClick={() => {
            if (isAgreed) {
              onConfirm();
            }
          }}
        />
      </div>
    </div>
  );
};

export default memo(InspectionAgreementsModal);
